/** A general lifecycle status must not hide the explicit signature status. */
export function contractSignatureStatus(
  summary: Record<string, unknown>,
  detail: Record<string, unknown> = {},
): string {
  for (const value of [
    detail.signed_status, summary.signed_status,
    detail.signature_status, summary.signature_status,
    detail.status, summary.status,
  ]) {
    if (typeof value === "string" && value.trim()) return value.toUpperCase();
  }
  return "NON COMMUNIQUÉ";
}
